export function facebookTrackLead() {
    try {
        fbq('track', 'Lead', {
            value: 10.00,
            currency: 'USD'
        });
    } catch (err) {
        console.error("Error tracking lead form submission for Facebook", err);
    }
}
